module.exports = __webpack_public_path__ + "images/application/loader-70dc8b29.svg";